import React from "react";

import { parseQueryParams } from "../../../libs/Util";
import { IActiveLearningMaterial } from "../../../state";
import Button from "../../../atoms/ActiveLearning/Button";
import ActiveLearningMaterial from "../../../organisms/ActiveLearningMaterial";

import styles from "./ActiveLearningSelectPage.module.scss";

export interface IActiveLearningSelectPageProps {
  active_learning_materials: IActiveLearningMaterial[];
  openGuideline: (teaching_material_id: string, lesson_id: number) => void;
  openProjection: (teaching_material_id: string, lesson_id: number) => void;
  openMaterials: (
    active_learning_material_code: string,
    lesson_no: number,
  ) => void;
  classList: number[];
  calling: boolean;
  availableItemCodes: string[];
}

export const ActiveLearningSelectPage = (
  props: IActiveLearningSelectPageProps,
) => {
  const material_code = parseQueryParams()["code"];
  const [materialCode, setMaterialCode] = React.useState(material_code);

  return (
    <div className={styles.wrapper} id="accordion">
      <div className={styles.buttonWrapper}>
        {props.availableItemCodes.includes("ECS001") ? (
          <Button
            variant={materialCode === "ECS001" ? "primary" : "secondaryBgWhite"}
            width={"240px"}
            height={"40px"}
            fontSize={"14px"}
            handleClick={() => setMaterialCode("ECS001")}
          >
            1周目
          </Button>
        ) : (
          ""
        )}
        {props.availableItemCodes.includes("ECS002") ? (
          <Button
            variant={materialCode === "ECS002" ? "primary" : "secondaryBgWhite"}
            width={"240px"}
            height={"40px"}
            fontSize={"14px"}
            handleClick={() => setMaterialCode("ECS002")}
          >
            2周目
          </Button>
        ) : (
          ""
        )}
      </div>
      {props.active_learning_materials.length > 0 &&
        props.active_learning_materials.map(
          material =>
            material.mitsuwa_id === materialCode && (
              <ActiveLearningMaterial
                key={material.mitsuwa_id}
                openGuideline={props.openGuideline}
                openProjection={props.openProjection}
                openMaterials={props.openMaterials}
                classList={props.classList}
                active_learning_material={material}
                calling={props.calling}
              />
            ),
        )}
    </div>
  );
};

export default ActiveLearningSelectPage;
